import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_59txwmdw7j: FaireBrandEntity = {
  token: "b_59txwmdw7j",
  type: "brand",
  name: "MillTown Bath & Candle Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/95a2f2e2303c20f21e98f291743cae12bbaab3f3ce1068e65932615a6fc746b2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/611e1f0479bcf26a5052791e5adbd2702a074d5f630447dcf883323f6396315f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/95a2f2e2303c20f21e98f291743cae12bbaab3f3ce1068e65932615a6fc746b2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/611e1f0479bcf26a5052791e5adbd2702a074d5f630447dcf883323f6396315f.jpeg",
  location: "Thomaston , GA, USA",
  minimumOrderDollars: 132,
  rating: 5,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "At MillTown Bath & Candle Company, we create beautifully crafted, clean, and luxurious bath, body, and home fragrance products you can feel good about using. Our scents are always 100% phthalate-free and free from carcinogens and reproductive toxins—so you can indulge worry-free. Every product is handmade in small batches with care, ensuring the highest quality for your self-care routine. ✨ ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:30.338Z",
    importedBy: "entity-db-cli",
  },
};
